var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c("div", { class: [_vm.className] }, [
        _vm.showFeedbackOptions
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex flex-row justify-content-center align-items-center alert",
                attrs: { role: "alert" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "content d-flex flex-nowrap justify-content-between align-items-center",
                  },
                  [
                    _vm.helpFeedback
                      ? _c("i", {
                          staticClass: "pr-3 far fa-question-circle",
                          attrs: {
                            title: _vm.helpFeedback,
                            "data-toggle": "tooltip-city",
                            "data-html": "true",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.descriptionFeedback
                      ? _c("span", {
                          staticClass: "description",
                          domProps: {
                            innerHTML: _vm._s(_vm.descriptionFeedback),
                          },
                        })
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn-group",
                    attrs: { role: "group", "aria-label": "Tools group" },
                  },
                  _vm._l(_vm.tools, function (tool, idx) {
                    return _c(
                      "button",
                      {
                        key: `feedback-tool-${idx}`,
                        staticClass: "btn btn-link btn-rounded min-w-auto",
                        attrs: {
                          type: "button",
                          "data-toggle": "tooltip-city",
                          "data-html": "true",
                          title: _vm.$t(tool.title),
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onClickTool(tool)
                          },
                        },
                      },
                      [
                        tool.icon
                          ? _c("i", { class: [tool.icon, tool.class] })
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }